import {Box, Divider as MuiDivider, FormControl, Grid, Typography} from "@material-ui/core";
import i18n from "i18next";
import FloorCounterInput from "./FloorCounterInput";
import CounterInput from "./CounterInput";
import * as Icon from "react-feather";
import React, {FC} from "react";
import {AccessibilityUnitLevel} from "../../../../../models/AccessibilityUnits";
import {Property} from "../../../../../models/Property";
import styled from "styled-components/macro";
import {spacing} from "@material-ui/system";

const Divider = styled(MuiDivider)(spacing);

type PropsType = {
  index: number,
  handleClick: () => void,
  levels: AccessibilityUnitLevel[],
  handleDelete: (index: number) => void,
  property: Property,
  handleChangeCounter: (field: string, value: number, index: number) => void,
  isQuantityAvailable: boolean
  isFloorAvailable: boolean
}

const FloorItem: FC<PropsType> = ({
  index,
  handleClick,
  levels,
  handleDelete,
  property,
  handleChangeCounter,
  isQuantityAvailable,
  isFloorAvailable
}) => {
  return (
    <Box mt={2} key={index}>
      <Grid container>
        <Grid item xs={5}>
          {isFloorAvailable ? (
            <Box display='flex' justifyContent='center'>
              <Typography variant="h6">
                {i18n.t("unitForm_locationFaq")}
              </Typography>
            </Box>
          ) : null}
          </Grid>
        <Grid item xs={5}>
          {isQuantityAvailable ? (
            <Box display='flex' justifyContent='center'>
              <Typography variant="h6">
                {i18n.t("unitForm_totalQuantity")}
              </Typography>
            </Box>
          ) : null}
        </Grid>
        <Grid item xs={2}>
          {index === 0 ? (
            <Box display="flex" justifyContent="flex-end" pr={0.45}>
              <img
                style={{ cursor: "pointer", height: 22, width: 22 }}
                onClick={handleClick}
                src="/static/img/icons/plussButton.svg"
                alt="plus"
              />
            </Box>
          ) : null}
        </Grid>
      </Grid>
      <Box mt={4}>
        <Grid container>
          <Grid item xs={5}>
            {isFloorAvailable ? (
              <Box display='flex' justifyContent='center'>
                <FormControl variant="outlined" style={{ maxWidth: "130px" }}>
                  <FloorCounterInput
                    value={levels[index]?.level ?? 0}
                    handleChangeCounter={handleChangeCounter}
                    index={index}
                    property={property}
                  />
                </FormControl>
              </Box>
            ) : null}
          </Grid>
          <Grid item xs={5}>
            {isQuantityAvailable ? (
              <Box display='flex' justifyContent='center'>
                <FormControl variant="outlined" style={{ maxWidth: "130px" }}>
                  <CounterInput
                    value={levels[index]?.number_of_units ?? 0}
                    handleChangeCounter={handleChangeCounter}
                    index={index}
                    property={property}
                  />
                </FormControl>
              </Box>
            ) : null}
          </Grid>
          <Grid item xs={2} style={{display: 'flex', justifyContent: 'end', alignItems: 'center'}}>
            <Icon.MinusSquare
              style={{ color: "#8bf0e2" }}
              onClick={() => handleDelete(index)}
            />
          </Grid>
        </Grid>
      </Box>
      <Divider mt={5} mb={4} />
    </Box>
  )
}

export default FloorItem